var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonDefault, IconWrapper, Loader } from "./styles";
import { Text } from "../Text";
import { Icon as IconComponent } from "../Icon";
var variants = {
    cta: "button2",
    h2: "button2",
    rounded: "button1",
    iconed: "button2",
};
var variantArray = Object.entries(variants);
export var Button = function (props) {
    var children = props.children, buttonVariant = props.buttonVariant, forceMobile = props.forceMobile, icon = props.icon, iconOnTheRight = props.iconOnTheRight, className = props.className, colorScheme = props.colorScheme, _a = props.outlined, outlined = _a === void 0 ? false : _a, _b = props.fullWidth, fullWidth = _b === void 0 ? false : _b, _c = props.loading, loading = _c === void 0 ? false : _c, otherProps = __rest(props, ["children", "buttonVariant", "forceMobile", "icon", "iconOnTheRight", "className", "colorScheme", "outlined", "fullWidth", "loading"]);
    var renderVariant = variantArray.find(function (_a) {
        var _b = __read(_a, 1), key = _b[0];
        return key === buttonVariant;
    }) || variantArray[0];
    return (_jsx(ButtonDefault, __assign({ "$buttonVariant": buttonVariant, "$colorScheme": colorScheme, "$forceMobile": forceMobile, "$outlined": outlined, "$fullWidth": fullWidth, className: className }, otherProps, { children: loading ? (_jsx(Loader, { size: 25, "$outlined": outlined })) : (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ textStyle: renderVariant[1], forceMobile: forceMobile }, { children: children })), icon && buttonVariant === "iconed" && (_jsx(IconWrapper, __assign({ className: iconOnTheRight ? "right-pos" : "" }, { children: _jsx(IconComponent, { name: icon }) })))] })) })));
};
Button.defaultProps = {
    disabled: false,
    outlined: false,
    forceMobile: false,
    colorScheme: "primary",
    buttonVariant: "cta",
    iconOnTheRight: false,
    fullWidth: false,
};
